module.exports = __webpack_public_path__ + "images/img-21.00264b52.jpg";